import React from 'react'
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const InfoIcon = ({title}) => {
    return (
        <Tooltip title={title}>
            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
        </Tooltip>
    )
}

export default InfoIcon;